<template>
	<div class="creatCase" v-if="caseData != null">
		<h3 v-if="$router.name == 'creatCase'">请根据报案信息，完成案件创建</h3>
		<h4>案件信息</h4>
		<div class="caseDeil">
			<ul>
				<li>报案时间：<span>{{formattingTime(caseData.obj.reportTs)}}</span></li>
				<li>报案人：{{caseData.obj.reportUser}}</li>
				<li>性别：{{caseData.victimList[0].obj.gender == 1 ? '男':'女'}}</li>
			</ul>
			<ul>
				<li>报案电话：{{caseData.obj.reporterContact}}</li>
				<li>出险时间：{{formattingTime(caseData.obj.updateAt)}}</li>
				<li>&nbsp;</li>
			</ul>
			<ul>
				<li>案件号码：{{caseData.obj.caseNo}}</li>
				<li>保单号码：{{caseData.victimList[0].obj.idNo}}</li>
				<li>
					<a :href="caseData.victimList[0].obj.insurancePaper">保单详情</a>
				</li>
			</ul>
			<ul>
				<li>案件信息来源：{{caseData.obj.caseSrc}}</li>
				<li>来源说明：{{setTxt(caseData.obj.caseSrcDesc)}}</li>
				<li>&nbsp;</li>
			</ul>
		</div>
		<h4>出险信息</h4>
		<div class="dangerMessage">
			<ul>
				<li>
					<span>出险地：</span>
					<span>{{setTxt(caseData.generalLocation.addr)}}</span>
				</li>
				<li>
					<span>事故类型：</span>
					<span>{{caseData.obj.accidentType || '未填写'}}</span>
				</li>
				<li>
					<span>是否团险：</span>
					<span>未填写</span>
				</li>
				<li>
					<span>受伤部位：</span>
					<span>{{setTxt(caseData.victimList[0].obj.injuredPart)||"未填写"}}</span>
				</li>
				<li>
					<span>天气灾害：</span>
					<span>{{caseData.obj.weatherTag || "无"}}</span>
				</li>
				<li>
					<span>事故经过：</span>
					<span>{{setTxt(caseData.obj.incidentDesc) || '无'}}</span>
				</li>
			</ul>
		</div>
		<template v-if="caseData.insuranceContact">
			<h4>保险对接人</h4>
			<div class="DockingPeople">
				<ul>
					<li>
						<span>保险公司对接人：</span>
						<span>{{caseData.insuranceContact.contactName}}</span>
					</li>
					<li>
						<span>对接人联系方式：</span>
						<span>{{caseData.insuranceContact.contactNo}}</span>
					</li>
					<li>
						<span>保险公司名称：</span>
						<span>{{caseData.insuranceContact.company}}</span>
					</li>
				</ul>
				<p>其他信息：{{caseData.insuranceContact.description}}</p>
			</div>
		</template>
		<template v-if="$route.name == 'creatCase'">
			<h4>创建案件</h4>
			<div class="creatCaseBox">
				<p>A、需要当地服务商介入的案件，请在对应分类下创建，以便救援人员后续跟进处理</p>
				<ul>
					<li  v-for="item in case_list" @click="tocase(item.id)" v-if="item.id == 800 || item.id == 900">{{item.name}}</li>
				</ul>
				<!-- <p>B、咨询类，可线上解决的案件，在此处创建</p>
				<ul class="yellow">
					<router-link tag='li' :to="{name:'callCase',query:{caseType:1},params:{caseList: caseData}}">咨询类案件</router-link>
				</ul> -->
			</div>
		</template>

		<h4 v-if="$route.query.status == '1' || $route.query.status == '2'">服务节点记录 <small v-if="$route.query.status == '1'" @click="centerDialogVisible=true">编辑服务节点</small></h4>
		<div class="fuwuNode">
			<ul>
				<li v-for="item in caseDataNode">
					<p>{{formattingTime(item.createAt)}}</p>
					<p></p>
					<p>{{item.description}}</p>
				</li>
			</ul>
		</div>
		<el-dialog title="编辑服务节点" :visible.sync="centerDialogVisible" width="830px" center>
			<ul class="dialogBox">
				<li v-for="(item,index) in caseDataNode">
					<div>
						<p>{{index + 1}}、</p>
						<el-date-picker class='time' v-model="item.createAt" type="datetime" placeholder="选择日期时间"> </el-date-picker>
						<!--<p class="text1">服务商:</p>
						<p class="text1">电话:</p>-->
						<p class="delete" @click="deleteNode1(index)">删除</p>
					</div>
					<textarea class="textarea" placeholder="请输入说明" v-model="item.description"></textarea>
				</li>
				<li v-for="(item,index) in nodeList">
					<div>
						<p>{{caseDataNode.length + 1}}、</p>
						<el-date-picker class='time' v-model="item.time" type="datetime" placeholder="选择日期时间"> </el-date-picker>
						<!--<p class="text1">服务商:</p>
						<p class="text1">电话:</p>-->
						<p class="delete" @click="deleteNode(index)">删除</p>
					</div>
					<textarea class="textarea" placeholder="请输入说明" v-model="item.description"></textarea>
				</li>
				<!--<li>
					<div>
						<p>{{nodeList.length + 1}}、</p>
						<el-date-picker class='time' v-model="value1" type="datetime" placeholder="选择日期时间"> </el-date-picker>
						<p class="text1">服务商:</p>
				    <p class="text1">电话:</p>
						<p class="delete" @click="centerDialogVisible1=true">插入关联信息</p>
					</div>
					<textarea class="textarea" placeholder="请输入说明"></textarea>
				</li>-->
			</ul>
			<p class="addnode" @click="addnode"> +添加节点</p>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false;getCaseNode()">确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog title="从系统中修改服务商&星使" :visible.sync="centerDialogVisible1" width="430px" center>
			<div class="tabBox">
				<span class="active">服务商</span>
				<span>星使</span>
			</div>
			<input class="tabBoxInput" type="text" placeholder="按名称搜索">
			<ul class="searchResult">
				<p>搜索结果</p>
				<li>
					<span>服务商送达时间可垃圾</span>
				</li>
				<li>
					<span>服务商送达时间可垃圾</span>
				</li>
			</ul>
		</el-dialog>
	</div>
</template>

<script>
	import { seversList, getCaseNum, detailOrdinaryCase,getCaseNode } from '@/views/axios/api.js';
	import constants from "@/util/constants.js";
	export default {
		data() {
			return {
				centerDialogVisible: false,
				centerDialogVisible1: false,
				token: JSON.parse(window.localStorage.getItem("data")).data,
				value1: '',
				case_list: [],
				caseData: null,
				caseDataNode:[],
				nodeList:[
					{createAt:'',description:'',time:'',caseId:this.$route.query.caseId}
				]
			}
		},
		mounted() {
			this.getSeverFun();
			this.getCasedetail()
		},
		methods: {
			setTxt(str,status){
				if(constants.setTxt(str,status)){
					return constants.setTxt(str,status)
				}else{
					return str
				}
			},
			addnode(){
				this.nodeList.push({createAt:'',description:'',time:'',caseId:this.$route.query.caseId})
			},
			deleteNode(index){
				this.nodeList.splice(index,1)
			},
			deleteNode1(index){
				this.caseDataNode.splice(index,1)
			},
			formattingTime(time) {
				return constants.time(time)
			},
			getSeverFun() { //门急诊就医
				var data = {
					token: this.token,
					parentId: 0
				}
				seversList(data)
					.then(res => {
						this.case_list = res.data.obj
					})
					.catch(err => {
						console.log(err)
					})
			},
			getCasedetail() {
				var data = {
					token: this.token,
					caseId: this.$route.query.caseId
				}
				detailOrdinaryCase(data)
					.then(res => {
						this.caseData = res.data.obj;
						this.caseDataNode=res.data.obj2
					})
					.catch(err => {
						console.log(err)
					})
			},
			tocase(id) {
				if(id == 600){
          console.log(this.caseData);
          this.$router.push({
            name:'newstar1',
            params:{
              caseList: this.caseData
            },
            query:{creat:1}
          })
          return
        }
        	if(id == 800){
          console.log(this.caseData);
          this.$router.push({
            name:'Familywealth',
            	params: {
						token: this.ttoken,
						insti: this.tinsti,
						flag: false,
						caseList: this.caseData
					},
					query: {
						caseId: this.$route.query.caseId,
						typeId: id,
						name: name,
            			creat:1
					}
          })
          return
        }
        if(id == 900){
          console.log(this.caseData);
          this.$router.push({
            name:'createRescue',
            	params: {
						token: this.ttoken,
						insti: this.tinsti,
						flag: false,
						caseList: this.caseData
					},
					query: {
						caseId: this.$route.query.caseId,
						typeId: id,
						name: name,
            			creat:1
					}
          })
          return
        }
				let name = "";
				this.case_list.map(v => {
					if(v.id == id) {
						name = v.name;
					}
				});
				this.$router.push({
					name: "appcase",
					params: {
						token: this.ttoken,
						insti: this.tinsti,
						flag: false,
						caseList: this.caseData
					},
					query: {
						caseId: this.$route.query.caseId,
						typeId: id,
						name: name,
            creat:1
					}
				});
			},
			getCaseNode(){
				console.log(this.nodeList)
				this.nodeList.forEach(item =>{
					item.createAt=item.time.getTime()
				})
				if(this.caseDataNode.length != 0){
					this.nodeList=[...this.nodeList,...this.caseDataNode]
				}
				var aaa=JSON.stringify(this.nodeList)
				var data={
					caseId:this.$route.query.caseId,
					plst:aaa,
					token:this.token
				}
				getCaseNode(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.getSeverFun();
						this.getCasedetail()
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped="scoped">
	* {
		box-sizing: border-box;
		outline: none;
	}

	.creatCase h3 {
		padding-top: 20px;
	}

	.creatCase h4 {
		margin-top: 20px;
	}

	.caseDeil {
		border: 1px solid #ccc;
		border-bottom: none;
		border-right: none;
		margin-top: 20px;
	}

	.caseDeil ul {
		overflow: hidden;
		line-height: 30px;
		border-bottom: 1px solid #ccc;
		color: #666;
		font-size: 14px;
	}

	.caseDeil ul li {
		float: left;
		width: 40%;
		border-right: 1px solid #ccc;
		padding-left: 20px;
	}

	.caseDeil ul li:last-child {
		width: 20%;
	}

	.dangerMessage ul {
		overflow: hidden;
		margin-top: 20px;
	}

	.dangerMessage ul li {
		float: left;
		padding-right: 20px;
	}

	.DockingPeople ul {
		overflow: hidden;
	}

	.DockingPeople ul li {
		float: left;
		width: 40%;
		line-height: 40px;
	}

	.DockingPeople ul li:last-child {
		width: 20%;
	}

	.creatCaseBox ul {
		overflow: hidden;
	}

	.creatCaseBox ul li {
		float: left;
		border: 1px solid #00A4EF;
		border-radius: 3px;
		height: 35px;
		line-height: 35px;
		margin-right: 40px;
		margin-top: 20px;
		width: 170px;
		text-align: center;
		color: #00A4EF;
		cursor: pointer
	}

	.creatCaseBox p {
		margin-top: 15px;
	}

	.creatCaseBox ul.yellow li {
		border: 1px solid #CF9236;
		color: #CF9236;
	}

	.creatCaseBox ul li.active {
		background: #d2eefb;
	}

	.creatCase h4 small {
		color: #00A4EF;
		cursor: pointer;
	}

	.fuwuNode ul li {
		overflow: hidden;
	}

	.fuwuNode ul li p {
		float: left;
		margin-top: 10px;
	}

	.fuwuNode ul li p:nth-child(1) {
		width: 20%;
	}

	.fuwuNode ul li p:nth-child(2) {
		width: 20%;
	}

	.fuwuNode ul li p:nth-child(3) {
		width: 50%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #00A4EF;
	}

	.dialogBox li>div {
		overflow: hidden;
		padding-right: 25px;
	}

	.dialogBox li p {
		float: left;
		line-height: 40px;
	}

	.dialogBox li .time {
		float: left;
	}

	.dialogBox .text1 {
		width: 200px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-left: 20px;
	}

	.dialogBox .delete {
		color: #00A4EF;
		margin-left: 10px;
		cursor: pointer;
		float: right;
	}

	.textarea {
		width: 95%;
		border: 1px solid #dcdfe6;
		margin: 20px;
		min-height: 80px;
		border-radius: 3px;
		padding: 10px;
		color: #666;
	}

	.addnode {
		text-align: center;
		color: #00A4EF;
		cursor: pointer;
	}

	.tabBox {
		text-align: center;
		height: 30px;
	}

	.tabBox span {
		padding: 0 20px;
		padding-bottom: 10px;
	}

	.tabBox span.active {
		color: #00A4EF;
		border-bottom: 2px solid #00A4EF;
	}

	.tabBoxInput {
		width: 100%;
		margin-top: 10px;
		height: 30px;
		padding: 0 10px;
		border-radius: 3px;
		border: 1px solid #ccc;
	}

	.searchResult p {
		text-align: center;
		color: #999;
		line-height: 30px;
	}

	.searchResult li {
		line-height: 30px;
	}

	.searchResult {
		max-height: 200px;
		overflow-y: auto;
	}
	.creatCase{width: 1200px;margin: 0 auto;background: white;padding: 20px;margin-top: 20px;padding-top: 5px !important;}
</style>


  



// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/creatCase.vue